var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaykaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 37,
    viewBox: "0 0 110 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo Payka"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54.8578 7.24219V26.8238C54.8578 27.0969 54.8578 27.57 54.8578 27.8236C54.8578 31.3985 52.3461 33.1689 48.2103 33.1689L44.9866 33.1836C43.6112 33.1836 42.8699 34.1005 42.8065 35.2759V36.0757L37.8708 36.0806C37.8708 36.0025 37.8708 35.9245 37.8708 35.8465C37.9538 31.9058 39.9583 29.6135 44.5281 29.6135L47.7373 29.6086C49.1126 29.6086 49.8539 29.0039 49.9173 27.8285V26.7019H44.5184C39.0462 26.7019 37.8708 22.9855 37.8708 19.3618V7.24219H42.8406V19.0253C42.8406 20.5031 42.943 21.8784 44.9573 21.8784H49.9271V7.24219H54.8578Z",
    fill: "#19297C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.8969 7.24219H20.2303L20.201 11.5048H28.8969C29.6675 11.5048 30.0723 11.9096 30.0723 12.6802V14.8602H23.4589C19.3963 14.8602 17.3479 16.6745 17.3479 20.2299V20.9323C17.3479 24.7608 19.3914 26.7068 23.4589 26.7068H35.0031V13.3435C35.0079 9.29545 32.9937 7.24219 28.8969 7.24219ZM30.0723 22.449H23.4589C22.6883 22.449 22.2835 22.1808 22.2835 21.6102V19.5276C22.2835 18.7571 22.6883 18.3864 23.4589 18.3864H30.0723V22.449Z",
    fill: "#19297C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M86.7346 7.24219H77.8094L75.1855 11.5048H86.7346C87.5051 11.5048 87.9099 11.9096 87.9099 12.6802V14.8602H81.2966C77.2339 14.8602 75.1855 16.6745 75.1855 20.2299V20.9323C75.1855 24.7608 77.2339 26.7068 81.2966 26.7068H92.8456V13.3435C92.8456 9.29545 90.8265 7.24219 86.7346 7.24219ZM87.9099 22.449H81.2966C80.526 22.449 80.1212 22.1808 80.1212 21.6102V19.5276C80.1212 18.7571 80.526 18.3864 81.2966 18.3864H87.9099V22.449Z",
    fill: "#19297C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M73.4934 26.7217L68.5627 26.712L65.1877 20.0206L62.6906 24.0393V26.712H57.7208V0H62.6906V17.0163L67.8945 7.23764H73.1276L67.7482 15.9433L73.4934 26.7217Z",
    fill: "#19297C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.3528 7.19375V11.6319C17.3528 15.8604 14.4753 18.6989 10.5736 18.6989L7.28641 18.7135C5.8818 18.7135 5.13073 19.3329 5.06245 20.5327V26.7168H0.0243856C0.0243856 26.6388 0.0243856 20.3912 0.0292627 20.3132C0.0487712 19.4402 0.165822 18.6647 0.390169 17.9771C1.19489 15.5092 3.33595 14.2753 6.80845 14.2753L10.0956 14.2607C11.5002 14.2607 12.2513 13.6413 12.3196 12.4415L12.3342 7.62781C12.3342 5.87692 11.5831 5.02831 10.281 5.02831H4.48207C4.48207 5.02831 4.47232 6.84747 4.46256 8.56909C4.45768 9.92981 4.44793 11.2808 4.44793 11.5832C2.40442 11.7197 0.94616 12.3732 0 13.4852V0H10.7638C12.8561 0 14.4899 0.580377 15.6019 1.75088C16.7529 2.95066 17.3528 4.76494 17.3528 7.19375Z",
    fill: "#19297C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M107.585 15.5284C108.724 15.5284 109.648 14.6047 109.648 13.4654C109.648 12.326 108.724 11.4023 107.585 11.4023C106.445 11.4023 105.522 12.326 105.522 13.4654C105.522 14.6047 106.445 15.5284 107.585 15.5284Z",
    fill: "#C49BBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M107.585 22.5616C108.724 22.5616 109.648 21.6379 109.648 20.4986C109.648 19.3592 108.724 18.4355 107.585 18.4355C106.445 18.4355 105.522 19.3592 105.522 20.4986C105.522 21.6379 106.445 22.5616 107.585 22.5616Z",
    fill: "#C49BBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M100.62 22.5616C101.76 22.5616 102.683 21.6379 102.683 20.4986C102.683 19.3592 101.76 18.4355 100.62 18.4355C99.4808 18.4355 98.5571 19.3592 98.5571 20.4986C98.5571 21.6379 99.4808 22.5616 100.62 22.5616Z",
    fill: "#C49BBB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M100.62 15.5284C101.759 15.5284 102.683 14.6047 102.683 13.4654C102.683 12.326 101.759 11.4023 100.62 11.4023C99.4805 11.4023 98.5569 12.326 98.5569 13.4654C98.5569 14.6047 99.4805 15.5284 100.62 15.5284Z",
    fill: "#C49BBB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaykaLogo);
export default __webpack_public_path__ + "static/media/payka-logo.5e2eee2456d9e6492fe9adf02a9fe72c.svg";
export { ForwardRef as ReactComponent };